import '../application';

/* Update certain other way to give links based on url param set on mypages by entity. */
$(document).ready(() => {
  const parsedUrl = new URL(window.location.href);
  const parsedUrlMypageParam = parsedUrl.searchParams.get('mypage');

  if (parsedUrlMypageParam) {
    $('.card__link-give-by').each(function () {
      updateURLTrackingParams($(this), parsedUrlMypageParam);
    });
  }
});

const updateURLTrackingParams = ($giveByLinkElement, parsedUrlMypageParam) => {
  const giveByLinkUrl = new URL($giveByLinkElement.attr('href'), window.location.origin);
  const utmParams = {
    utm_source: 'partner',
    utm_medium: 'website',
    utm_campaign: `202410_stbaldricks_evergreen_${parsedUrlMypageParam}`
  };

  for (const [key, value] of Object.entries(utmParams)) {
    giveByLinkUrl.searchParams.set(key, value);
  }

  $giveByLinkElement.attr('href', giveByLinkUrl.toString());
};
